import React, { useState, useEffect } from "react";
import { Box, Grid, Typography, useMediaQuery } from '@material-ui/core';
import { useParams } from "react-router-dom";
// import "yup-phone";
import {
  FormProvider,
  useForm,
  useFieldArray,
  useWatch,
} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";


import Loader from "../components/Loader/Loader";
import Navbar from "../components/Navbar/Navbar";
import Step1 from "./Step1/Step1";
import Step2 from "./Step2/Step2";
import Step3 from "./Step3/Step3";
import Step4 from "./Step4/Step4";
import FormFooter from "../components/FormFooter/FormFooter";
import { validationSchema } from "../utils/validations";
import { GET_OFFER_BASE_URL, getFormData } from "../api/api";
import useStyles from "./styles";
import googleEvent from '../api/GoogleEvent';
import { projectTitle } from '../constants/settings';
import ThankYouPage from "./Step4/organisms/ThankYouPage/ThankYouPage";
// import testOrder from '../api/testOrder3';

const MultiStepForm = () => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [apiData, setApiData] = useState({});

  const onDownSM = false // useMediaQuery(({ breakpoints: { down } }) => down("xs"));


  const steps = ["Itinerary", "Passengers", onDownSM ? "Protection" : "Ticket Protection", "Payment"];
  const { token, priceQuoteId } = useParams();

  useEffect(() => {
    let mounted = true;
    const url = `${GET_OFFER_BASE_URL}${token}`;
    getFormData(url).then((data) => {
      if (mounted) {
         setApiData(data);
      }
    });
    return () => (mounted = false);
  }, []);

  return (
    <>
      <Navbar apiData={apiData} />
      <main className={classes.mainSection}>
        <Grid container>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              mb={1}
            >
              <Typography variant="h2" color="secondary" align="center">
                Review Details and Confirm Your Trip
              </Typography>
            </Box>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              mb={{ xs: 1, sm: 2 }}
            >
              <Box
                className={classes.formMenu}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                {steps.map((label, index) => (
                  <Box
                    key={index}
                    className={`${classes.stepperItem} ${index < activeStep ? classes.activeItem : ""
                      } ${activeStep === index ? classes.actualStep : ""}
                  `}
                  >
                    {label}
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>
        {typeof apiData === "object" && Object.keys(apiData).length > 1 ? (
          <FormWrap
            setActiveStep={setActiveStep}
            activeStep={activeStep}
            classes={classes}
            steps={steps}
            apiData={apiData}
            priceQuoteId={priceQuoteId}
          />
        ) : (
          <Grid container>
            <Grid item xs={12} className={classes.mainForm}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
              >
                {typeof apiData === "string" ? (
                  <Typography variant="h2">{apiData}</Typography>
                ) : (
                  <Loader />
                )}
              </Box>
            </Grid>
          </Grid>
        )}
      </main>
    </>
  );
};

const FormWrap = ({
  setActiveStep,
  activeStep,
  classes,
  steps,
  apiData,
  priceQuoteId,
}) => {
  const arrayCards = [
    {
      card_id: 'card_1',
      cardNumber: "",
      cardHolderName: "",
      expirationDate: null,
      cvv: "",
      country: "",
      city: "",
      state: "",
      street: "",
      postalCode: "",
      cardHolderEmail: "",
      cardPhoneNumber: "",
    },
  ];

  const defaultValues = {
    flight: null,
    passengers: [],
    contactPhoneNumber: null,
    itinerarySwitch: false,
    contactDetailsSwitch: false,
    email: "",
    travelCare: "",
    cards: arrayCards,
    tips: 100,
    acceptTips: false,
    confirmTerms: false,
    splitPayment: false,
    manualSplit: false,
    cardsAmmount: [],
    products: [],
    productsFinal: []
  };

  if (!!apiData.result) {
    Object.keys(apiData.result).forEach(field => {
      defaultValues[field] = apiData.result[field]
    })
  }

  //Validation handler
  const currentValidationSchema = validationSchema[activeStep];

  //Initialize form
  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(currentValidationSchema),
    mode: "onChange",
  });

  const { handleSubmit, trigger, control, setValue, getValues } = methods;

  React.useEffect(() => {
    if (!apiData.result) {
      setValue("flight", `${priceQuoteId}`)
    }
  }, [apiData]);

  //useFieldArray for dynamic fields
  const { fields, append, remove } = useFieldArray({
    control,
    name: "passengers",
  });

  const flightValue = useWatch({
    control,
    name: "flight",
  });

  const selectedFlight =
    apiData?.priceQuotes?.find((item) => item?.id == flightValue) ||
    apiData?.priceQuotes.find((item) => item?.id == priceQuoteId);

  if (!selectedFlight?.parts?.multiple) {
    delete selectedFlight?.parts?.multiple
  }

  const passengersCount = selectedFlight?.passengers?.all || apiData?.passengers?.all

  React.useEffect(() => {
    if (!apiData.result) {
      for (let i = 1; i <= passengersCount; i++) {
        append({
          firstName: "",
          lastName: "",
          middleName: "",
          birthDate: null,
          gender: "",
          seatPreference: "",
          mealPreference: "",
          specialAsistance: "",
          knownTravelerNumber: "",
          knownTravelerNumberCheck: false,
          globalEntryNumber: "",
          globalEntryNumberCheck: false,
          tsaPrecheckNumber: "",
          tsaPrecheckNumberCheck: false,
          frequentFlyer: [{
            airline_pk: '',
            frequent_flyer_number: ''
          }],
          frequentFlyerCheck: false,
        });
      }
    }
  }, [apiData]);


  googleEvent.onSetPriceQuote(selectedFlight, apiData)

  const cards = useWatch({
    control,
    name: "cards",
    keyName: 'card_id'
  });

  const tipsValue = useWatch({
    control,
    name: "tips",
  });

  //Main form methods
  const onSubmit = (data) => {
    data.cards = data.cards.map(card => {
      card.expirationDate = card.expirationDate.toDateString()
      return card
    })

    data.passengers = data.passengers.map(passenger => {
      if (typeof passenger.birthDate !== "string") {
        passenger.birthDate = passenger.birthDate.toDateString()
      }
      if (!passenger.globalEntryNumberCheck) {
        passenger.globalEntryNumber = null
      }
      if (!passenger.knownTravelerNumberCheck) {
        passenger.knownTravelerNumber = null
      }
      if (!passenger.tsaPrecheckNumberCheck) {
        passenger.tsaPrecheckNumber = null
      }
      if (!passenger.frequentFlyerCheck) {
        passenger.frequentFlyer = []
      }
      return passenger
    })

    data.token = window.location.pathname.split('/').slice(2, 3)[0]

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    };

    fetch(`/api/store/${flightValue}`, requestOptions)
      .then(async res => {
        //console.log("res", res, requestOptions);
        if (res.ok) {
          googleEvent.onSuccess()
          handleNext();
          return res.json()
        } else {
          alert(await res.text());
          handleBack();
          return res?.statusText;
        }
      }).catch(err => {
        alert("Sorry, something went wrong. Please try again");
        handleBack();
        return err;
      });
    // console.log(flightValue, "data submit flightValue");
    // console.log(data, "data submit");
    handleNext();
  };

  const handleNext = async () => {
    const isStepValid = await trigger();

    if (isStepValid) setActiveStep((prevActiveStep) => prevActiveStep + 1);

    setTimeout(()=>{
      window.scroll({ top: 0, behavior: "smooth" })
    }, 100)
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Step1
            apiData={apiData}
            handleNext={handleNext}
            activeStep={activeStep}
            tipsValue={tipsValue}
            selectedFlight={selectedFlight}
            priceQuoteId={priceQuoteId}
          />
        );

      case 1:
        return (
          <Step2
            activeStep={activeStep}
            passengers={passengersCount}
            fields={fields}
            append={append}
            remove={remove}
            operatorInfo={apiData?.operatorInfo}
            extras={apiData?.extras}
            handleBack={handleBack}
            handleNext={handleNext}
            selectedFlight={selectedFlight}
            tipsValue={tipsValue}
            flightValue={flightValue}
            airlines={apiData?.airlines}
          />
        );

      case 2:
        return (
          <Step3
            handleBack={handleBack}
            handleNext={handleNext}
            apiData={apiData}
            tipsValue={tipsValue}
            selectedFlight={selectedFlight}
          />
        );
      case 3:
        return (
          <Step4
            apiData={apiData}
            handleNext={handleSubmit(onSubmit)}
            activeStep={activeStep}
            handleBack={handleBack}
            selectedFlight={selectedFlight}
            cards={cards}
            tipsValue={tipsValue}
          />
        );

      case 4:
        return (
          <Box
            className={classes.thankYouPage}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <Typography variant="h1" component="h1" gutterBottom>Loading, please wait...</Typography>
          </Box>
        );

      case 5:
        return (
          <ThankYouPage
            selectedFlight={selectedFlight}
            apiData={apiData}
            airports={apiData?.airports}
            passengers={getValues('passengers')}
            total={getValues('totalAmount')}
          />
        );
    }
  };
  return (
    <Grid container>
      <Grid item xs={12}>
        <FormProvider {...methods}>
          <form style={{ paddingBottom: "50px", height: "100%" }}>
            <Grid container className={classes.instructions}>
              <Grid item xs={12} style={{ height: "100%" }}>
                {getStepContent(activeStep)}
              </Grid>
            </Grid>
            <FormFooter
              handleNext={handleNext}
              handleSubmit={handleSubmit}
              onSubmit={onSubmit}
              steps={steps}
              activeStep={activeStep}
              apiData={apiData}
              priceQuoteId={priceQuoteId}
              tipsValue={tipsValue}
            />
          </form>
        </FormProvider>
      </Grid>
    </Grid>
  );
};

export default MultiStepForm;
